<p-panel>
  <p-header>
    <span>
      <i class="fas fa-mobile-alt" aria-hidden="true"></i> {{'TwoFactor.userprefs.header' | translate}}</span>
  </p-header>
  <div class="row p-h-m">
    <div class="ui-widget-content col-12" [innerHTML]="'TwoFactor.userprefs.intro' | translate">
    </div>
    <div class="col-12">
      <div *ngIf="!twoFAMandatory">
        <span *ngIf="user.requires2FA">{{'TwoFactor.userprefs.2fa_active' | translate}}</span>
        <span *ngIf="!user.requires2FA">{{'TwoFactor.userprefs.2fa_inactive' | translate}}</span>
        <p-inputSwitch onLabel="Activado" offLabel="Desactivado" [ngModel]="user.requires2FA"
          (onChange)="toggle2FAConfig($event)" class="btn" #switch2FA>
        </p-inputSwitch>
      </div>
      <div class="m-t-xs" *ngIf="twoFAMandatory && !show2FAConfig">
        <button pButton type="button" icon="fas fa-edit" class="btn btn-primary" (debounceClick)="reconfigureQrCode()"
          appDebounceClick label="{{'General.configure' | translate }}"></button>
      </div>
    </div>
    <div *ngIf="show2FAConfig" class="col-12">
      <user-2fa-config (validCode)="qrCodeValida($event)"></user-2fa-config>
    </div>
  </div>
</p-panel>